<style scoped lang="less">
  .statistics {
    margin-bottom: 10px;
    margin-left: 70%;
    label {
      font-weight: 600;
    }
  }
</style>
<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">CRM管理</Breadcrumb-item>
        <Breadcrumb-item>打卡分单</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" label-position="left">
        <Row :gutter="32">
          <Col :span="8">
            <FormItem label="注册时间">
              <Row>
                <Col :span="11">
                  <DatePicker type="date" format="yyyy-MM-dd" placeholder="请选择开始日期"
                             @on-change="startTimeDateChange"
                             v-model="startTime" style="width: 100%;"></DatePicker>
                </Col>
                <Col :span="1" style="text-align: center">-</Col>
                <Col :span="11">
                <DatePicker type="date" format="yyyy-MM-dd" placeholder="请选择结束日期"
                             @on-change="endTimeDateChange"
                             v-model="endTime" style="width: 100%;"></DatePicker>
                </Col>
              </Row>
            </FormItem>
          </Col>
          <Col :span="6">
            <FormItem label="学生" :label-width="60">
              <Input placeholder="ID/手机号/姓名" name="searchKeyword"
                     v-model="queryParam.searchKeyword"></Input>
            </FormItem>
          </Col>
          <Col :span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
        <Row type="flex" justify="end">
          <Col :span="12" class-name="btn-group">
            <Button type="info"  @click="manualAssign">手动分配</Button>
            <Button type="info"  @click="moveUser">移至公库</Button>
            <span v-if="havePermission">
              <Button type="warning" @click="autoAssignOpen(1)" v-if="autoAssignTag === -1">开启自动分配</Button>
              <Button type="warning" @click="autoAssignOpen(-1)" v-if="autoAssignTag === 1">关闭自动分配</Button>
            </span>
            <span v-else>
            </span>
            <Button type="warning"  @click="editAssignWeight">编辑分配权重</Button>
            <Button type="info"  @click="addMonthTarget">添加月度目标</Button>
          </Col>
        </Row>
    </div>
    <List :height="680" ref="dataList" :tableColumns="title" :reload="reload" listUrl="/userList/listPageData"
          :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange"></List>
    <UserInfoModal :value="showUserInfoModal" v-on:close="showUserInfoModal = false" :uid="uid" :successCallback="search"></UserInfoModal>
    <manual-assign-modal :value="showManualAssignModal" :userList="selectionUser" @on-close="showManualAssignModal=false" :successCallback="search"></manual-assign-modal>
    <edit-assign-weight-modal :value="showEditAssingWeightModal" :userList="selectionUser" @on-close="showEditAssingWeightModal=false" :successCallback="search"></edit-assign-weight-modal>
    <add-month-target-modal :value="showAddMonthTargetModal" @on-close="showAddMonthTargetModal=false"></add-month-target-modal>
  </div>

</template>
<script>
  import UserInfoModal from './UserInfoModal.vue'
  import AdviserFloatModal from '../common/AdviserFloatModal.vue'
  import ManualAssignModal from './ManualAssignModal.vue'
//  import RuleButton from '../common/RuleButton.vue'
  import EditAssignWeightModal from './EditAssignWeightModal.vue'
  import AddMonthTargetModal from './AddMonthTargetModal.vue'
import Row from 'iview/src/components/grid/row';
  export default {
    components: {
      UserInfoModal, AdviserFloatModal, ManualAssignModal, EditAssignWeightModal, AddMonthTargetModal
    },
    data () {
      let $constant = this.$constant
      return {
        modal1: false,
        showUserInfoModal: false,
        uid: null,
        showManualAssignModal: false,
        showEditAssingWeightModal: false,
        showAddMonthTargetModal: false,
        editData: null,
        searchLoading: false,
        reload: 0,
        connectionStatusList: $constant.connectionStatus,
        autoAssignTag: -1,
        havePermission: false,
        selectionUser: [],
        adviserList: [],
        adviserGroupList: $constant.adviserGroup,
        startTime: '',
        endTime: '',
        queryParam: {
          startGmtCreate: '',
          endGmtCreate: '',
          searchKeyword: '',
          isAdviser: '',
        },
        title: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: 'ID/姓名',
            align: 'center',
            // width: 200,
            render: (h, params) => {
              let row = params.row
              let inviteId = row.inviteId
              if (inviteId) {
                return h('span',
                  [
                    h('a', {on: {click: () => this.openInfoModal(row.id)}}, row.id + '-' + row.nickname),
                    h('span', {style: {color: 'red'}}, '(推荐)')
                  ]
                )
              } else {
                return h('a', {on: {click: () => this.openInfoModal(row.id)}}, row.id + '-' + row.nickname)
              }
            }
          },
          {
            title: '手机号码',
            align: 'center',
            key: 'mobile',
            // width: 140,
            render: (h, params) => {
              if (params.row.mobile.startsWith('n')){
                return h('span', '')
              }
              return h('Poptip', {
                props: {
                  trigger: 'hover'
                }
              }, [
                h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3)
                  + "****" + params.row.mobile.substring(7) : params.row.mobile),
                // 当前行展示的数据
                h('div', {slot: 'content'}, params.row.mobile)
              ])
            }
          },
          {
            title: '城市',
            align: 'center',
            // width: 120,
            render: (h, params) => {
              let province = params.row.province
              let city = params.row.city
              let address = ''
              if (province && province !== '未知') {
                address = address + province
              }
              if (city && city !== '未知') {
                address = address + city
              }
              return h('span', address)
            }
          },
          {
            title: '注册渠道',
            align: 'center',
            // width: 140,
            key: 'regType',
            render: (h, params) => {
              let name = params.row.regType || ''
              let type = params.row.channelType || ''
              if (type && name && type !== name) {
                return h('span', name + '（' + type + '）')
              }
              return h('span', name || type)
            }
          },
          {
            title: '名单标签',
            align: 'center',
            // width: 120,
            render: (h, params) => {
              let assignNum = params.row.assignNum
              let assignNumEnum = $constant.getEnum($constant.assignNumEnum, assignNum)
              return h('div', assignNumEnum && assignNumEnum.text)
            }
          },
          {
            title: '推荐人',
            align: 'center',
            key: 'inviteName',
            render: (h, params) => {
              let inviteId = params.row.inviteId
              let inviteName = params.row.inviteName
              if (inviteId) {
                return h('a', {on: {click: () => this.openInfoModal(inviteId)}}, inviteId + '-' + inviteName)
              }
            }
          },
          {
            title: '创建人',
            // width: 150,
            align: 'center',
            key: 'createName',
          },
          {
            title: '注册时间',
            align: 'center',
            key: 'regTime',
            // width: 190,
          },
        ],
      }
    },
    mounted: function () {
      let self = this
      self.havePermission = false
      let permissions = self.$store.get('permissions')
      if (permissions) {
        if (JSON.stringify(permissions).indexOf('all') >= 0) {
          self.havePermission = true
        } else {
          this.$http.post('/common/getPermissionByUrl', {url: '/adviser/updateAutoAssignTag'}).then(function (res) {
            if (res.data) {
              self.havePermission = true
            }
          })
        }
      }
    },
    created: function () {
      if (this.$store.get('permissions').indexOf('all') > 0) {
        this.queryParam.teamType = 0
      } else if (this.$store.get('adviserInfo')) {
        this.queryParam.teamType = this.$store.get('adviserInfo').teamType
      }
      this.getAdviserList()
      this.queryAutoAssignTag()
    },
    methods: {
      openInfoModal(val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserExperienceList'}
        })
        window.open(href, '_blank')
      },
      queryAutoAssignTag () {
        let self = this
        self.$http.get('/userList/autoAssign').then(function (res) {
          if (res.data) {
            self.autoAssignTag = res.data
          }
        })
      },
      search () {
        this.startTime = this.queryParam.startGmtCreate
        this.endTime = this.queryParam.endGmtCreate
        this.reload = new Date().getTime()
      },
      getAdviserList () {
        let self = this
        self.$http.get('/adviser/listNoPage?teamType=0').then(function (res) {
          if (res && res.data) {
            self.adviserList = res.data
          }
        })
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      selectionChange (selection) {
        this.selectionUser = selection
      },
      startTimeDateChange (value) {
        this.queryParam.startGmtCreate = value
      },
      endTimeDateChange (value) {
        this.queryParam.endGmtCreate = value
      },
      ok () {
        this.$Message.info('Clicked ok')
      },
      cancel () {
        this.$Message.info('Clicked cancel')
      },
      editUserInfo (row) {
        this.uid = row.id
        this.showUserInfoModal = true
      },
      getAdviserInfo (obj) {
        if (obj) {
          console.log(obj)
          this.queryParam.adviserId = obj.adviserId
          this.queryParam.teamType = obj.teamType
        }
      },
      manualAssign () {
        if (this.selectionUser.length <= 0) {
          this.$Message.warning('请选择需分配课程顾问的学生！')
          return
        }
        this.showManualAssignModal = true
      },
      moveUser () {
        let self = this
        if (this.selectionUser.length <= 0) {
          this.$Message.warning('请选择学生！')
          return
        }
        self.$Modal.confirm({
          title: '温馨提示',
          content: '是否<span style="color: red">移除</span>此资源?',
          width: 300,
          okText: '确认',
          onOk: () => {
            for (let i = 0; i < self.selectionUser.length; i++) {
              self.$http.post('/userList/crmResourceUpdate', {id: self.selectionUser[i].id}).then(function (res) {
              })
            }
            self.search()
          }
        })
      },
      autoAssignOpen (value) {
        let self = this
        var content = '是否确认开启自动分配功能？开启后所有新注册学生将按权重分配给课顾！'
        if (value === -1) {
          content = '是否确认关闭自动分配功能？关闭后将停止自动分配课顾！'
        }
        self.$Modal.confirm({
          title: '提示',
          content: content,
          width: 300,
          loading: false,
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            self.$http.post('/adviser/updateAutoAssignTag', {tag: value}).then(function (res) {
              if (res && res.data) {
                self.$Message.success('操作成功!')
                self.queryAutoAssignTag()
              } else {
                self.$Message.error('操作失败!')
              }
            })
          },
          onCancel: () => {

          }
        })
      },
      editAssignWeight () {
        this.showEditAssingWeightModal = true
      },
      addMonthTarget () {
        this.showAddMonthTargetModal = true
      }
    },
    watch: {
      startGmtCreate (val) {
        this.startTime = val
      },
      endGmtCreate (val) {
        this.endTime = val
      }
    }
  }
</script>

<style scoped>
  .btn-group {
    margin-top: 24px;
    text-align: end;
  }
</style>



// WEBPACK FOOTER //
// AdviserPunchList.vue?5eedf50f